import { render, staticRenderFns } from "./OrdemServico.vue?vue&type=template&id=041333e9"
import script from "./OrdemServico.vue?vue&type=script&lang=js"
export * from "./OrdemServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports